module.exports = __webpack_public_path__ + "static/media/share-gift-icon.160fa3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/share-gift-icon.png
// module id = 559
// module chunks = 6